/* eslint-disable */
import React, { Component } from "react";
import { Input, Box } from "@chakra-ui/react";
import SaveIcon from "@material-ui/icons/Save";
import EditIcon from "@material-ui/icons/Edit";
import { show } from "redux-modal";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { getEnums, getSections } from "../../utils/store/actions/survey.action";
import {
  getAllIssuerSigners,
  getAllProductSigners,
  getColors,
  getFund,
  updateFund,
} from "../../utils/store/actions/funds.actions";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import Fab from "@material-ui/core/Fab";
import { Tabs, TabList, TabPanels, Tab, TabPanel } from "@chakra-ui/react";

import { Button, Paper } from "@material-ui/core";
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import ModalFundAddUpdateSigners from "../../components/Modal/ModalFundAddUpdateSigners";
import FundSignerList from "./FundSignerList";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import FundTab from "./FundTab";
import PartTab from "./PartTab";
import { getFundEnvelopes, addDirectory } from "../../utils/store/actions/document.actions";

const styles = (theme: Theme) =>
  createStyles({
    input: {
      "&:focus": {
        outline: "none !important",
        border: "1px solid red",
      },
    },
    fundCards: {
      borderRadius: "12px",
      maxWidth: "1200px",
      margin: "0 auto",
      display: "grid",
      gridGap: "1rem",
      [theme.breakpoints.up("lg")]: {
        gridTemplateColumns: "repeat(2, 1fr)",
      },
      [theme.breakpoints.up("xl")]: {
        gridTemplateColumns: "repeat(3, 1fr)",
      },
    },
    backPageComponent: {
      display: "flex",
      alignItems: "center",
      margin: "1%",
    },
    backButton: {
      borderRadius: "5px",
      backgroundColor: "white",
      margin: "1%",
    },
    backInput: {
      marginLeft: "3%",
      display: "flex",
      alignItems: "center",
      fontSize: "20px",
      color: "black",
    },
    card: {
      borderRadius: "12px",
      margin: "1%",
    },
    tabList: {
      borderBottom: "2px solid #4b0084",
      boxSizing: "border-box",
      marginLeft: "20px",
      width: "100%",
      marginRight: "5%",
    },
    signersComponent: {
      display: "flex",
      width: "30%",
      flexDirection: "column",
    },
  });
class Fund extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }
  handleBackPage = () => {
    window.location.href = `/admin/funds`;
  };
  handleNav = (index: any) => {
    this.setState({ defaultIndex: index });
  };
  handleSave = (e: any) => {
    this.props.updateFund(this.state.fund);
  };

  async componentDidMount() {
    this.props.getEnums();
    this.props.getFund().then(() => {
      this.setState({ fund: this.props.Funds.fund });
    });
    if (window.location.href.indexOf("tab") > -1) {
      this.setState({ defaultIndex: 1 });
    }
  }

  render() {
    const { Surveys } = this.props;
    const { classes } = this.props;
    const { t } = this.props;
    return this.props.Funds.fund && Surveys.enums ? (
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <ModalFundAddUpdateSigners />
        {/* CONTENT */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}
        >
          {/* BACK INPUT */}
          <div className={classes.backPageComponent}>
            <Fab
              onClick={(e: any) => this.handleBackPage()}
              className={classes.backButton}
              size="small"
            >
              <ArrowBackIosIcon
                style={{ fontSize: "12px" }}
                className={classes.extendedIcon}
              />
            </Fab>
            <div className={classes.backInput}>
              {this.state.editFundName ? (
                <Input
                  id="person.name"
                  value={this.state.fund?.person?.name}
                  onChange={(e) =>
                    this.setState({
                      fund: {
                        ...this.state.fund,
                        person: {
                          ...this.state.fund.person,
                          name: e.target.value,
                        },
                      },
                    })
                  }
                />
              ) : (
                this.state.fund?.person?.name
              )}
              {this.state.editFundName ? (
                <Button
                  onClick={(e) => {
                    this.handleSave(e),
                      this.setState({
                        editFundName: false,
                      });
                  }}
                >
                  <SaveIcon />
                </Button>
              ) : (
                <Button
                  onClick={() =>
                    this.setState({
                      editFundName: true,
                    })
                  }
                >
                  <EditIcon />
                </Button>
              )}
            </div>
          </div>
          {/* TABS */}

          <Tabs
            index={this.state.defaultIndex}
            onChange={this.handleNav}
            variant="unstyled"
          >
            <Box display="flex" marginLeft="20px">
              <TabList className={classes.tabList}>
                <Tab
                  id="clientTab"
                  _selected={{
                    color: "brand.bf3",
                    borderBottom: "5px solid #4b0084",
                  }}
                >
                  <div>{t("Information")}</div>
                </Tab>

                <Tab
                  id="operationTabActive"
                  _selected={{
                    color: "brand.bf3",
                    borderBottom: "5px solid #4b0084",
                  }}
                >
                  <div>{t("PART")}</div>
                </Tab>
              </TabList>
            </Box>
            <TabPanels>
              <TabPanel>
                <FundTab />
              </TabPanel>
              <TabPanel>
                <PartTab />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </div>
        <div className={classes.signersComponent}>
          <FundSignerList />
        </div>
      </div>
    ) : (
      <Paper className={classes.paper}>
        <Loader
          type="ThreeDots"
          color="#4B0084"
          height={100}
          width={100}
          timeout={3000} //3 secs
        />
      </Paper>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getFund,
  updateFund,
  show,
  getEnums,
  getAllIssuerSigners,
  getAllProductSigners,
  getFundEnvelopes,
  getSections,
  addDirectory,
  getColors
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(Fund)));
